import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { SearchSuggestionConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { SearchSuggestionsService } from './api/searchSuggestions.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class SearchSuggestionApiModule {
    public static forRoot(configurationFactory: () => SearchSuggestionConfiguration): ModuleWithProviders<SearchSuggestionApiModule> {
        return {
            ngModule: SearchSuggestionApiModule,
            providers: [ { provide: SearchSuggestionConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: SearchSuggestionApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('SearchSuggestionApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
